
import { DueDiligenceClient } from '@/store/dueDiligence/types';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';



@Component({
    name: 'CPDueDiligenceReminderOverview'
})

export default class CPDueDiligenceReminderOverview extends Vue {
    private filterRiskCategory: number = 1;

    async created() {
        await this.getClients();
    }

    public get loading() {
        return this.$store.state.dueDiligence.isLoading;
    }

    public setCategory(category: number): void {
        this.filterRiskCategory = category;
    }

    public filterClients(category: number): DueDiligenceClient[] {
        return this.$store.getters['dueDiligence/getClients'](category) ?? [];
    }

    private async getClients(): Promise<void> {
        await this.$store.dispatch('dueDiligence/getClients');
    }

    public closeModal(): void {
        localStorage.setItem('OverviewModal-' + this.$store.state.account.details.bostonId, JSON.stringify(Date.now()));
        this.$store.dispatch('dueDiligence/toggleReminderOverviewModal');
    }
}


